import "./styles.scss";
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import Filters from "./FiltersHome";
import CompoundCard from "components/Website/Cards/CompoundCard";
import ResaleCard from "components/Website/Cards/ResaleCard";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "components/Website/Layouts/Footer";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters } from "store/filter/actions";
import Skeleton from "components/Website/Skeleton";
import projectImg from "assets/images/project.png";
import projectImg2 from "assets/images/project2.png";
import projectImg3 from "assets/images/project3.png";
import projectImg4 from "assets/images/project4.png";
import projectImg5 from "assets/images/project5.png";
import bg from "assets/images/bg.png";
import { useTranslation } from "react-i18next";
import http from "services/HttpService";
import HearForm from "./HearForm";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Offers from "./Offers";
import Explore from "./Explore";
import {
	authenticate,
	setCurrencyRed,
	setLoadingHome,
} from "store/Auth/actions";
import Loader from "common/Loader";

const Home = (props) => {
	const { t } = useTranslation();
	const homeService = new HomeService();
	const filterData = useSelector((state) => state.filter);
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const loadedBefore = useSelector((state) => state.Auth?.loadedBefore);
	const lang = useSelector((state) => state.Auth?.lang);
	const [loading, setLoading] = useState(false);

	useEffect(() => http.setLang(AuthData.lang), [AuthData.lang]);
	useEffect(() => {
		// if (filterData.homeCompounds.length === 0 &&AuthData.lang.length) {
		if (!loadedBefore) {
			dispatch(setLoadingHome({ loadingHome: true }));
		}
		if (!!AuthData?.currency?.currency_code) {
			homeService.getPopulerData().then((response) => {
				setLoading(true);
				if (response && response.status === SuccessOk) {
					dispatch(
						appendFilters({
							bestCompounds: response.data.best_compounds
								? response.data.best_compounds
								: [],
							homeCompounds: response.data.compounds
								? response.data.compounds
								: [],
							homeResales: response.data.resales
								? response.data.resales?.slice(0, 3)
								: [],
							homeNewProjects: !!response?.data?.new_project_compounds
								? response?.data?.new_project_compounds
								: [],
						})
					);
				}
				setTimeout(
					() =>
						dispatch(
							setLoadingHome({ loadingHome: false, loadedBefore: true })
						),
					2000
				);
				// dispatch(setLoadingHome(false));
				setLoading(false);
			});
		} else {
			setTimeout(
				() =>
					dispatch(setLoadingHome({ loadingHome: false, loadedBefore: true })),
				2000
			);
		}
		// }
	}, [AuthData?.currency]);

	const checkAuth = (compound) => {
		if (AuthData.token && AuthData.userType === "user") {
			props?.history.push(`/compound-details/${compound?.id}`);
		} else {
			dispatch(
				authenticate({ navigateTo: `/compound-details/${compound?.id}` })
			);
			props?.history.push(`/login`, {
				navigateTo: `/compound-details/${compound?.id}`,
			});
		}
	};

	return (
		<React.Fragment>
			<div className="websitPages">
				<MetaTags>
					<title>{t("Homepage")}</title>
				</MetaTags>
				<div>
					<Filters history={props.history} />
					<Explore history={props.history} />
					<div className="recommendedProjects mt-md-5 mt-4">
						<div className="container-fluid">
							<div className="px-md-5 py-2">
								<div className="pb-4 d-md-flex align-items-center justify-content-between px-3">
									<h2 className=" mb-lg-3 title text-primary">
										<span
											dangerouslySetInnerHTML={{
												__html: t("Recommended Projects"),
											}}
											className="bask-font mx-0"></span>
									</h2>
									<button
										className="btn view-All-link"
										type={"button"}
										onClick={() => {
											props.history.push(
												"/compounds",
												"recommended_compounds_hidden"
											);
										}}>
										{t("View More")}
									</button>
								</div>
								<Row>
									{!loading ? (
										filterData?.homeCompounds?.map((compound, index) => {
											return (
												<Col xl={4} md={6} key={index} className="mb-4">
													<CompoundCard
														compound={compound}
														history={props.history}
														loaction={props.loaction}
													/>
												</Col>
											);
										})
									) : (
										<Skeleton.HomeCompounds />
									)}
								</Row>
							</div>
						</div>
					</div>
					<Offers />
					<Container fluid className="px-lg-5">
						<div className="topProgects overflow-hidden">
							<div className="mb-5 home-title d-lg-flex justify-content-between align-items-center px-3 px-md-0">
								<h2 className="fw-bold pt-2 title text-primary">
									<span
										className="gotham-font"
										dangerouslySetInnerHTML={{
											__html: t("Top Projects title"),
										}}></span>
								</h2>
								<div
									className="d-md-flex align-items-center justify-content-between"
									style={{ gap: "32px" }}>
									<p className="text-primary allYouNeed">
										<span className="d-block">
											{t("All You Need To Know About")}
										</span>
										<span className="d-block">
											{t("Trending and upcoming projects")}
										</span>
									</p>
									<p className="text-primary allYouNeed-mobile">
										<span className="d-block">
											{t(
												"All You Need To Know About Trending and upcoming projects"
											)}
										</span>
									</p>
									<button
										className="btn view-All-link"
										type={"button"}
										onClick={() => {
											props.history.push("/compounds", "top_compounds_hidden");
										}}>
										{t("View All")}
									</button>
								</div>
							</div>
							<div className="row px-2 px-md-0">
								{filterData?.bestCompounds?.length >= 1 && (
									<div className="col-lg-4 col-md-6 pb-3">
										<div className="position-relative projectName rounded-4">
											<div
												onClick={() => checkAuth(filterData?.bestCompounds[0])}
												className="cursor-pointer">
												<img
													src={
														filterData?.bestCompounds[0]?.images[0]?.path || bg
													}
													alt="best"
												/>
												<div className="sectionAbsolute text-center">
													<h5 className="text-white mb-1">
														{filterData?.bestCompounds[0]?.name[lang]}
													</h5>
													<p className="textLight mb-1">
														{
															filterData?.bestCompounds[0]
																?.available_units_count
														}{" "}
														Property
													</p>
												</div>
											</div>
										</div>
									</div>
								)}
								{filterData?.bestCompounds?.length >= 2 && (
									<div className="col-lg-8 col-md-6 px-3 pb-3">
										<div className="position-relative projectName rounded-4">
											<div
												onClick={() => checkAuth(filterData?.bestCompounds[1])}
												className="cursor-pointer">
												<img
													src={
														filterData?.bestCompounds[1]?.images[0]?.path || bg
													}
													alt="best"
												/>
												<div className="sectionAbsolute text-center">
													<h5 className="text-white mb-1">
														{filterData?.bestCompounds[1]?.name[lang]}
													</h5>
													<p className="textLight mb-1">
														{
															filterData?.bestCompounds[1]
																?.available_units_count
														}{" "}
														Property
													</p>
												</div>
											</div>
										</div>
									</div>
								)}
								{filterData?.bestCompounds?.length >= 3 && (
									<div className="col-lg-6 pb-3 mt-3">
										<div className="position-relative projectName rounded-4">
											<div
												onClick={() => checkAuth(filterData?.bestCompounds[2])}
												className="cursor-pointer">
												<img
													src={
														filterData?.bestCompounds[2]?.images[0]?.path || bg
													}
													alt="best"
												/>
												<div className="sectionAbsolute text-center">
													<h5 className="text-white mb-1">
														{filterData?.bestCompounds[2]?.name[lang]}
													</h5>
													<p className="textLight mb-1">
														{
															filterData?.bestCompounds[2]
																?.available_units_count
														}{" "}
														Property
													</p>
												</div>
											</div>
										</div>
									</div>
								)}
								{filterData?.bestCompounds?.length >= 4 && (
									<div className="col-lg-3 col-md-6 mt-3 pb-3">
										<div className="position-relative projectName rounded-4">
											<div
												onClick={() => checkAuth(filterData?.bestCompounds[3])}
												className="cursor-pointer">
												<img
													src={
														filterData?.bestCompounds[3]?.images[0]?.path || bg
													}
													alt="best"
												/>
												<div className="sectionAbsolute text-center">
													<h5 className="text-white mb-1">
														{filterData?.bestCompounds[3]?.name[lang]}
													</h5>
													<p className="textLight mb-1">
														{
															filterData?.bestCompounds[3]
																?.available_units_count
														}{" "}
														Property
													</p>
												</div>
											</div>
										</div>
									</div>
								)}
								{filterData?.bestCompounds?.length >= 5 && (
									<div className="col-lg-3 col-md-6 mt-3 pb-3">
										<div className="position-relative projectName rounded-4">
											<div
												onClick={() => checkAuth(filterData?.bestCompounds[4])}
												className="cursor-pointer">
												<img
													src={
														filterData?.bestCompounds[4]?.images[0]?.path || bg
													}
													alt="best"
												/>
												<div className="sectionAbsolute text-center">
													<h5 className="text-white mb-1">
														{filterData?.bestCompounds[4]?.name[lang]}
													</h5>
													<p className="textLight mb-1">
														{
															filterData?.bestCompounds[4]
																?.available_units_count
														}{" "}
														Property
													</p>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>

						<div className="mt-5 mb-4 container-fluid">
							<div className="mb-5 home-title d-lg-flex justify-content-between align-items-center px-3">
								<h2 className="fw-bold pt-2 title text-primary">
									<span
										className="gotham-font"
										dangerouslySetInnerHTML={{
											__html: t("Most Visited Resale title"),
										}}></span>
								</h2>
								<div
									className="d-md-flex align-items-center justify-content-between"
									style={{ gap: "32px" }}>
									<p className="text-primary allYouNeed">
										<span className="d-block">{t("All You Need To Know")}</span>
										<span className="d-block">
											{t("About Resale Properties")}
										</span>
									</p>
									<p className="text-primary allYouNeed-mobile">
										<span className="d-block">
											{t("All You Need To Know About Resale Properties")}
										</span>
									</p>
									<button
										className="btn view-All-link"
										type={"button"}
										onClick={() => {
											props.history.push("/resales", "resales");
										}}>
										{t("View All")}
									</button>
								</div>
							</div>
							<Row>
								{!loading ? (
									filterData?.homeResales?.map((resale, index) => {
										return (
											<Col xl={4} md={6} key={index}>
												<ResaleCard
													resale={resale}
													history={props.history}
													loaction={props.loaction}
												/>
											</Col>
										);
									})
								) : (
									<Skeleton.HomeResales />
								)}
							</Row>
						</div>
						<HearForm />
					</Container>
				</div>
			</div>
			<Footer />
		</React.Fragment>
	);
};

export default Home;
